export const createFunctionNode = ({ activeElement, setElements, setActiveElement, getLayoutedElements, label }) => {
  setElements(els => {
    let newNode;
    let newNodesList = [];
    const newCreateButtonElseId = `n-${String(Math.random()).replace('.', '')}`;
    const newNodeId = `n-${String(Math.random()).replace('.', '')}`;
    const newEdgeId = `e-${String(Math.random()).replace('.', '')}`;
    const createButton = els.find(el => el.id === 'create-button');

    let prevTarget = els.find(el => el.source === activeElement.id)?.target;
    let newEls = els.filter(el => el.id !== 'create-button' && el.target !== 'create-button');

    newEls = newEls.map(el => {
      if (el.source === activeElement.id) {
        const newEl = el;
        newEl.source = newCreateButtonElseId;
        return newEl;
      }
      return el;
    });

    newNode = {
      id: newNodeId,
      type: 'buttonnode',
      data: {
        text: label,
        isHandleBottom: true,
        isHandleTop: true,
        className: 'function-node',
        type: 'function',
        lastCreateId: newCreateButtonElseId,
        functional: true,
      },
    };

    newEls = newEls.filter(el => el.source !== activeElement.id);

    newNodesList = [
      newNode,
      {
        id: `e-p-${newEdgeId}`,
        source: activeElement.id,
        target: newNodeId,
        type: 'smoothstep',
      },
      {
        id: `${newEdgeId}-true`,
        source: newNodeId,
        target: `${newCreateButtonElseId}-true`,
        type: 'smoothstep',
      },
      {
        id: `${newEdgeId}-false`,
        source: newNodeId,
        target: `${newCreateButtonElseId}-false`,
        type: 'smoothstep',
      },
      {
        id: `from-${newEdgeId}-true`,
        source: `${newCreateButtonElseId}-true`,
        target: newCreateButtonElseId,
        type: 'smoothstep',
      },
      {
        id: `from-${newEdgeId}-false`,
        source: `${newCreateButtonElseId}-false`,
        target: newCreateButtonElseId,
        type: 'smoothstep',
      },
    ];

    const createButtonElse = [
      {
        id: `${newCreateButtonElseId}-true`,
        type: 'buttonnode',
        data: {
          text: '+',
          isHandleTop: true,
          isHandleBottom: true,
          className: 'create-node-else',
          type: 'create-else',
          label: 'true',
        },
        className: 'create-else',
      },
      {
        id: `${newCreateButtonElseId}-false`,
        type: 'buttonnode',
        data: {
          text: '+',
          isHandleTop: true,
          isHandleBottom: true,
          className: 'create-node-else',
          type: 'create-else',
          label: 'false',
        },
        className: 'create-else',
      },
      {
        id: newCreateButtonElseId,
        type: 'buttonnode',
        data: {
          text: '+',
          isHandleTop: true,
          isHandleBottom: true,
          className: 'create-node-else',
          type: 'create-else',
        },
        className: 'create-else',
      },
    ];

    let objectElements = [...newEls, ...newNodesList, ...createButtonElse, createButton];
    objectElements.map(el => {
      if (el?.data?.type === 'create-else' && !objectElements.find(elf => elf?.source === el.id)) {
        const newCreateButtonElseId = `n-${String(Math.random()).replace('.', '')}`;
        objectElements = [
          ...objectElements,
          {
            id: `e-${newCreateButtonElseId}`,
            source: el.id,
            target: 'create-button',
            type: 'smoothstep',
            data: { typesmooth: 'to-create' },
          },
        ];
      }
    });

    objectElements = getLayoutedElements(objectElements, 'TB');

    setActiveElement(newNode);

    return objectElements;
  });
};
